<template>
  <div class="detail-digital">
    <!--  :posterImg="businessInfo.banner.posterImg" -->
    <SecondaryBanner
      height="945px"
      :icon="businessInfo.banner.icon"
      :title="businessInfo.banner.title"
      :subTitle="businessInfo.banner.subTitle"
      :bgImage="businessInfo.banner.bgImg"
      :downLoadBtn="businessInfo.banner.downloadBtnList"
      :videoUrl="businessInfo.banner.videoUrl"
    />
    <AnchorTabs :tabList="tabs" />
    <div class="introduction" id="all">
      <div
        class="content"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <div class="intro-left">
          <div class="title">
            什么是<i class="m-l-4">{{ businessInfo.name }}</i
            >？
          </div>
          <div class="desc">
            <template v-if="Array.isArray(businessInfo.all.content)">
              <div
                v-for="(item, index) in businessInfo.all.content"
                :key="'all_desc_' + index"
              >
                {{ item }}
              </div>
            </template>
            <template v-else>
              {{ businessInfo.all.content }}
            </template>
          </div>
          <div class="btn flex-row">
            <DownLoad
              v-for="(item, index) in businessInfo.banner.downloadBtnList"
              :key="index"
              :btnLabel="item.otherLabel"
              :fileUrl="item.fileUrl"
              :fileName="item.fileName"
              style="margin-right: 20px"
            />
          </div>
        </div>
        <div class="imgs">
          <el-carousel
            ref="carousel_all"
            height="320px"
            arrow="never"
            indicatorPosition="none"
            @change="(index) => handerChange(index, 'all')"
          >
            <el-carousel-item
              v-for="(item, index) in businessInfo.all.imgLists"
              :key="'all_' + index"
            >
              <!-- <img class="carouselImg c_img" :src="item.img" alt="" /> -->
              <el-image
                class="carouselImg c_img"
                :src="item.img"
                :preview-src-list="[item.img]"
              >
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="SamplePaginationBox">
            <SamplePagination
              :total="businessInfo.all.imgLists.length"
              :pageSize="1"
              :currentPage="currentPage.all"
              theme="dark"
              @current-change="
                ({ pageIndex }) => handleCurrentChange({ pageIndex }, 'all')
              "
            >
              <template #customPage>
                {{ currentCarouselTitle_all || "-" }}
              </template>
            </SamplePagination>
          </div>
        </div>
      </div>
    </div>
    <div class="highlights" id="highlights">
      <div
        class="content"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <div class="title">
          为什么选择<i class="m-l-4">{{ businessInfo.name }}</i
          >？
        </div>
        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in businessInfo.highlights.lists"
            :key="'highlights_' + index"
          >
            <img :src="item.icon" alt="" class="imgs" />
            <div class="highlights-right">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="function" id="function">
      <div class="content">
        <div
          class="title"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <i class="m-r-4">{{ businessInfo.name }}</i
          >的功能！
        </div>
        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in businessInfo.function.lists"
            :key="'function_' + index"
            v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
          >
            <template v-if="index % 2 === 0">
              <el-image
                class="imgs c_img"
                :src="item.img"
                :preview-src-list="[item.img]"
              >
              </el-image>
              <div class="function-content">
                <div class="item-title text-wrap">{{ item.title }}</div>
                <template v-if="Array.isArray(item.content)">
                  <template v-if="businessInfo.name == 'EICAD'">
                    <div
                      class="item-content circle"
                      v-for="(e, a) in item.content"
                      :key="'right_' + index + '_' + a"
                    >
                      {{ e }}
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="item-content"
                      v-for="(e, a) in item.content"
                      :key="'right_' + index + '_' + a"
                    >
                      {{ e }}
                    </div>
                  </template>
                  <!-- <el-carousel
                      ref="carousel_function"
                      height="200px"
                      arrow="never"
                      indicatorPosition="none"
                      @change="(index) => handerChange(index, 'function')"
                    >
                      <el-carousel-item
                        v-for="(v, i) in item.content"
                        :key="'func_carousel_' + i"
                      >
                        {{ v }}
                      </el-carousel-item>
                    </el-carousel> -->

                  <!-- <template v-if="businessInfo.combination.lists.length > 1">
                      <SamplePagination
                        :total="item.content.length"
                        :pageSize="1"
                        :currentPage="currentPage.function"
                        theme="dark"
                        @current-change="
                          ({ pageIndex }) =>
                            handleCurrentChange({ pageIndex }, 'function')
                        "
                      />
                    </template> -->
                </template>
                <div v-else class="item-content">{{ item.content }}</div>
              </div>
            </template>
            <template v-else>
              <div class="function-content">
                <div class="item-title">{{ item.title }}</div>
                <template v-if="Array.isArray(item.content)">
                  <div
                    class="item-content"
                    v-for="(e, a) in item.content"
                    :key="'left_' + index + '_' + a"
                  >
                    {{ e }}
                  </div>
                </template>
                <div v-else class="item-content">{{ item.content }}</div>
              </div>
              <el-image
                class="imgs c_img"
                :src="item.img"
                :preview-src-list="[item.img]"
              ></el-image>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="support" id="support">
      <div
        class="content"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <div class="title">{{ businessInfo.support.title }}</div>
        <div class="list">
          <div class="list-item">
            <div class="item-title">帮助文档</div>
            <div class="item-content">- 查询软件的功能与各项说明</div>
            <div
              class="item-link"
              @click="openInCurrentTab(businessInfo.support.documnentUrl)"
            >
              <div class="link-text">查看文档</div>
              <div class="link-icon"><i class="el-icon-right"></i></div>
            </div>
          </div>
          <div class="list-item">
            <div class="item-title">演示教学</div>
            <div class="item-content">- 查看软件的演示与教学视频</div>
            <div
              class="item-link"
              @click="
                $uniFun.openInCurrentTab(`${businessInfo.support.videosUrl}`)
              "
            >
              <div class="link-text">查看视频</div>
              <div class="link-icon"><i class="el-icon-right"></i></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact" id="contact">
      <ProductGet
        :width="1200"
        :title="businessInfo.contact.title"
        :subTitle="businessInfo.contact.subTitle"
        :bgImage="businessInfo.contact.bgImg"
        :downLoadBtn="{
          label: businessInfo.contact.downLoadBtnText,
          fileUrl: businessInfo.contact.downLoadBtnUrl,
          show: true,
        }"
        :contactBtn="{
          label: businessInfo.contact.contactBtnText,
        }"
      />
    </div>
    <div class="combination" id="combination">
      <div class="content">
        <div
          class="combination-top"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <el-carousel
            ref="carousel_combination"
            height="206px"
            arrow="never"
            direction="vertical"
            indicatorPosition="none"
            @change="(index) => handerChange(index, 'combination')"
          >
            <el-carousel-item
              v-for="(item, index) in businessInfo.combination.lists"
              :key="'combination_' + index"
            >
              <div class="list-item">
                <el-image
                  class="imgs c_img"
                  :src="item.img"
                  :preview-src-list="[item.img]"
                ></el-image>
                <div class="combination-content">
                  <div class="item-title">{{ item.title }}</div>
                  <div class="item-title">{{ item.subTitle }}</div>
                  <div class="item-content text-wrap">{{ item.content }}</div>
                  <div class="item-link flex">
                    案例详情<img src="@/assets/images/icon_case.svg" alt="" />
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <template v-if="businessInfo.combination.lists.length > 1">
            <SamplePagination
              :total="businessInfo.combination.lists.length"
              :pageSize="1"
              :currentPage="currentPage.combination"
              theme="dark"
              @current-change="
                ({ pageIndex }) =>
                  handleCurrentChange({ pageIndex }, 'combination')
              "
            />
          </template>
        </div>
        <div
          class="combination-bottom"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="eicad-box">
            <div class="title">
              {{ businessInfo.combination.title }}
            </div>
            <div
              v-for="(item, index) in businessInfo.combination.softwares"
              :key="index"
            >
              <div class="icon">
                <img class="c_img" :src="item.icon" alt="" />
              </div>
              <div class="desc">
                {{ item.desc }}
              </div>
              <div class="btn">
                <!-- <div
                  class="btn-item"
                  @click="$uniFun.openInCurrentTab(`/download?anchor=software`)"
                >
                  Download {{ item.name }}
                  <img
                    src="../../../assets/images/digitalImg/arrow_right.png"
                    alt=""
                  />
                </div> -->
                <div
                  class="btn-item"
                  @click="
                    $uniFun.openInCurrentTab(`/academy?anchor=${item.name}`)
                  "
                >
                  了解关于{{ item.name }}的更多！
                  <!-- <img
                    src="../../../assets/images/digitalImg/arrow_right.png"
                    alt=""
                  /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SecondaryBanner from "@/components/SecondaryBanner.vue";
import AnchorTabs from "@/components/AnchorTabs.vue";

import SamplePagination from "@/components/SamplePagination.vue";
import DownLoad from "@/components/DownLoad";
import ProductGet from "@/components/ProductGet.vue";
import ContractUsModal from "@/components/ContractUsModal.vue";
export default {
  props: ["businessInfo"],
  components: {
    SecondaryBanner,
    AnchorTabs,
    SamplePagination,
    DownLoad,
    ProductGet,
  },
  data() {
    return {
      activeName: "all",
      tabs: [
        {
          name: "全部",
          value: "all",
        },
        {
          name: "亮点",
          value: "highlights",
        },
        {
          name: "功能",
          value: "function",
        },
        {
          name: "用户支持",
          value: "support",
        },
        {
          name: "软件购买",
          value: "contact",
        },
        {
          name: "工具组合",
          value: "combination",
        },
      ],
      currentPage: {
        all: 1,
        function: 1,
        combination: 1,
      },
      currentCarouselTitle_all: "",
    };
  },
  created() {
    this.currentCarouselTitle_all =
      this.businessInfo.all.imgLists[this.currentPage.all - 1].title;
  },
  methods: {
    handerChange(index, type) {
      this.currentPage[type] = index + 1;
      if (type == "all") {
        this.currentCarouselTitle_all =
          this.businessInfo.all.imgLists[index].title;
      }
    },
    handleCurrentChange({ pageIndex }, type) {
      this.currentPage[type] = pageIndex;
      if (type == "all") {
        this.$refs.carousel_all.setActiveItem(pageIndex - 1);
      } else if (type == "function") {
        this.$refs.carousel_function[0].setActiveItem(pageIndex - 1);
      } else if (type == "combination") {
        this.$refs.carousel_combination.setActiveItem(pageIndex - 1);
      }
    },
    openInCurrentTab(url) {
      console.log("url", url);
      if (url.includes("helpDocuments")) {
        this.$uniFun.openUrl(`${url}`);
      } else {
        this.$uniFun.openInCurrentTab(`${url}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.detail-digital {
  width: 100%;
  height: 100%;
  background: #fff;
  color: #1d1d1f;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    .title {
      font-weight: 400;
      font-size: 24px;
      word-break: keep-all;
      i {
        font-weight: 600;
        font-style: normal;
      }
    }
    .desc {
      margin: 24px 0;
      font-size: 14px;
      line-height: 32px;
      text-indent: 2em;
      text-align: justify;
    }

    .item-title {
      margin-bottom: 12px;
      font-weight: 600;
      font-size: 18px;
    }
    .item-content {
      font-size: 12px;
      line-height: 18px;
      text-align: justify;
    }
  }
  .banner {
    width: 100%;
    height: 944px;
    background: url("../../../assets/images/digitalImg/airoad_bg.png") no-repeat
      center center;
    background-size: cover;
    .content {
      .img {
        margin-top: 20px;
      }
      .title {
        margin: 40px 0 24px;
        font-weight: 600;
        font-size: 28px;
        color: #ffffff;
      }
      .sub-title {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      .btn {
        margin: 40px 0;
      }
      .video {
        width: 100%;
        height: 590px;
        padding: 10px;
        box-sizing: border-box;
        background: #1d1d1d;
        border-radius: 8px;
        border: 1px solid #454545;
      }
    }
  }
  .tabs {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #d8d8d8;
    :deep(.el-tabs__nav-wrap::after) {
      display: none;
    }
    .content {
      padding: 0;
    }
  }
  .introduction {
    height: 460px;
    .content {
      display: flex;
      justify-content: space-between;
      padding-top: 60px;
      opacity: 0;
      .intro-left {
        width: 527px;

        .btn {
          border-top: 1px solid #d8d8d8;
          padding-top: 24px;
        }
      }
      .imgs {
        width: 592px;
        .carouselImg {
          width: 100%;
          height: 100%;
        }
        .SamplePaginationBox {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 12px;
        }
      }
    }
  }

  .highlights {
    height: 288px;
    background: #f7f7f7;
    overflow: hidden;
    .content {
      opacity: 0;
      .list {
        display: flex;
        justify-content: space-between;
        gap: 40px; /* 卡片之间的间距 */
        margin-top: 24px;
        .list-item {
          // width: 516px;
          flex: 1;
          height: 160px;
          background: #ffffff;
          border: 1px solid #bdbdbd;
          display: flex;
          align-items: center;
          padding: 0 60px 0 32px;
          .highlights-right {
            min-height: 108px;
          }
          .imgs {
            width: 64px;
            height: 64px;
            margin-right: 40px;
          }
          .item-title {
            font-size: 20px;
            line-height: 20px;
            font-weight: 600;
            color: #333333;
            margin-bottom: 16px;
          }
          .item-content {
            font-size: 14px;
            line-height: 24px;
            color: #666666;
          }
        }
      }
    }
  }
  .function {
    // height: 1140px;
    .content {
      .list {
        margin-top: 40px;
        .list-item {
          width: 100%;
          height: 290px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 56px;
          opacity: 0;
          .imgs {
            width: 516px;
            height: 290px;
          }
          .function-content {
            width: 604px;
            padding: 40px;
            .item-title {
              margin-bottom: 16px;
              font-weight: 600;
              font-size: 20px;
              color: #333333;
              line-height: 20px;
            }
            .item-content {
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              line-height: 24px;
              text-indent: 2em;
            }
            .item-content.circle {
              text-indent: inherit;
            }
          }
        }
      }
    }
  }
  .support {
    height: 334px;
    background: #f7f7f7;
    overflow: hidden;
    .content {
      .list {
        display: flex;
        gap: 40px;
        justify-content: space-between;
        margin-top: 24px;
        .list-item {
          flex: 1;
          height: 190px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0 32px 0 60px;
          .item-link {
            display: flex;
            justify-content: space-between;
            margin-top: 12px;
            border-top: 1px solid #f0f0f0;
            padding-top: 12px;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 24px;
            cursor: pointer;
            &:hover {
              .link-text {
                color: #0035fb;
              }
              .link-icon {
                i {
                  color: #0035fb;
                }
              }
            }
          }
          .link-icon {
            i {
              font-size: 22px;
            }
          }
          .item-title {
            margin-bottom: 16px;
            font-weight: 600;
            font-size: 20px;
            color: #333333;
            line-height: 20px;
          }
          .item-content {
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
          }
        }
      }
    }
  }
  .combination {
    .content {
      .combination-top {
        width: 100%;
        height: 206px;
        overflow: hidden;
        opacity: 0;
        position: relative;
        .list-item {
          width: 100%;
          height: 100%;
          display: flex;
          .imgs {
            width: 364px;
            height: 206px;
          }
          .combination-content {
            padding: 22px 0 0 70px;
            flex: 1;
            height: 100%;
            .item-title {
              font-weight: 600;
              font-size: 20px;
              line-height: 32px;
              color: #333333;
              margin-bottom: 0;
            }
            .item-content {
              font-weight: 400;
              font-size: 14px;
              line-height: 24px;
              color: #666666;
              margin-top: 12px;
              margin-bottom: 12px;
            }
            .item-link {
              font-weight: 400;
              font-size: 14px;
              line-height: 14px;
              color: #000000;
              cursor: pointer;
              &:hover {
                color: #0035fb;
              }
              > img {
                margin-left: 12px;
              }
            }
          }
        }
        .samplePage-box {
          position: absolute;
          bottom: 0;
          left: 434px;
          z-index: 10;
          background: #ffffff;
        }
      }
      .combination-bottom {
        padding-top: 36px;
        margin-top: 40px;
        border-top: 1px solid #d8d8d8;
        opacity: 0;
        .title {
          color: #000000;
        }
        .icon {
          margin: 40px 0 24px;
          img {
            height: 32px;
          }
        }
        .desc {
          margin: 24px 0;
          font-size: 14px;
          line-height: 24px;
          text-indent: inherit;
          color: #666666;
        }
        .btn {
          display: flex;
          .btn-item {
            display: flex;
            align-items: center;
            border-radius: 2px;
            border: 1px solid #333333;
            padding: 8px 24px;
            cursor: pointer;
            margin-right: 10px;
            font-size: 14px;
            line-height: 14px;
            color: #333333;
            font-weight: 400;
            &:hover {
              border-color: #2f69f2;
              color: #2f69f2;
            }
            img {
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
  .pagination {
    position: absolute;
    bottom: -20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1d1d1d;
  }
  .trigger-box {
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    .trigger-item {
      font-weight: 500;
      font-size: 12px;
      color: #1d1d1f;
      line-height: 24px;
    }
  }
  .btnIcon {
    cursor: pointer;
    &:hover {
      color: #2f69f2;
    }
  }

  .circle::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #d9d9d9;
    margin-right: 12px;
  }
  // .samplePage-box {
  //   color: red;
  //   :deep(.el-pagination) {
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //   }
  // }
  :deep(.el-tabs__item.is-active),
  :deep(.el-tabs__item:hover) {
    font-weight: 500;
    color: #1d1d1f;
  }
  :deep(.el-tabs__item) {
    font-size: 20px;
  }
  :deep(.el-tabs__active-bar) {
    background: #2f69f2;
  }
}
</style>
<style lang="scss">
.detail-digital {
  .tabs-content {
    padding: 0;
    width: 1200px !important;
    margin: 0 auto;
    box-sizing: border-box;
  }
}
</style>
